import cookieService from '../cookieService.js';
import {
  beginCheckout as ga4BeginCheckout,
  purchase as ga4Purchase,
  newsletterRegistration as ga4NewsletterRegistration,
  viewItem as ga4ViewItem,
  searchItemsResults as ga4SearchItemsResults,
  viewItemList as ga4ViewItemList,
  viewCart as ga4ViewCart,
  addShippingInfo as ga4AddShippingInfo,
  addToCart as ga4AddToCart,
  addPaymentInfo as ga4AddPaymentInfo,
  closePopUp as ga4ClosePopUp,
  popUpButtonClick as ga4PopUpButtonClick,
  init as initGoogleAnalytics4,
  setConfigGoogleAnalytics4,
  recordGA4BannerClick,
  recordGA4PromoImagesClick,
  recordGA4InfoboxClick,
  recordGA4NewsHomepageClick,
  recordGA4HelpClick,
  recordGA4CategoryClick,
  recordGA4LogonClick,
  recordGA4RegisterClick,
} from './ga4Service.js';
import {
  beginCheckout as adsBeginCheckoutSendConversion,
  purchaseDynamicRemarketing,
  purchaseConversion,
  adsSearchItemResultsDynamicRemarketing,
  adsViewItemListDynamicRemarketing,
  adsViewItemDynamicRemarketing,
  adsAddToCartDynamicRemarketing,
  adsAddToCartConversion,
  newsletterRegistration as adsNewsletterRegistrationSendConversion,
  initConversions,
} from './adsService.js';
import {
  init as initFbq,
  addToCart as fbqAddToCart,
  fbqPixelId,
  pageView as fbqPageView,
  beginCheckout as fbqBeginCheckout,
  newsletterRegistration as fbqNewsletterRegistration,
  contact as fbqContact,
  search as fbqSearch,
  addPaymentInfo as fbqAddPaymentInfo,
  viewItem as fbqViewItem,
  purchase as fbqPurchase,
} from './facebookService.js';

import { logDebug, logWarn, logError, logEvent } from '../../tracing.js';
import { isArray } from 'lodash';
import { validateGoogleData } from '../data/dataPageService.js';

const pageTypes = {
  view_item: 'view_item',
  view_item_list: 'view_item_list',
  cart: 'cart',
  view_search_results: 'view_search_results',
  registration: 'registration',
  contact: 'contact',
  view_cart: 'view_cart',
  add_shipping_info: 'add_shipping_info',
  add_payment_info: 'add_payment_info',
  purchase: 'purchase',
};

const _validateEcommPageType = () => {
  if (!window.ecomm_pagetype) {
    throw new Error('window.ecomm_pagetype is not defined');
  }
  return window.ecomm_pagetype;
};
const _validateEcommTransactionId = () => {
  if (!window.ecomm_transactionid) {
    logError('window.ecomm_transactionid is not defined');
    throw new Error('window.ecomm_transactionid is not defined');
  }

  if (window.ecomm_transactionid === '00000000-0000-0000-0000-000000000000') {
    logError(
      'Skipping because orderId happens to be 00000000-0000-0000-0000-000000000000',
    );
    throw new Error(
      'Skipping because orderId happens to be 00000000-0000-0000-0000-000000000000',
    );
  }
  return window.ecomm_transactionid;
};
const _validateEcommTotalValue = () => {
  if (!window.ecomm_totalvalue) {
    logError('window.ecomm_totalvalue is not defined');
    throw new Error('window.ecomm_totalvalue is not defined');
  }
  return window.ecomm_totalvalue;
};
const _validateEcommTotalValueEuro = () => {
  if (!window.ecomm_totalvalueeuro) {
    logError('window.ecomm_totalvalueeuro is not defined');
    throw new Error('window.ecomm_totalvalueeuro is not defined');
  }
  return window.ecomm_totalvalueeuro;
};

const _validateEcommCurrency = () => {
  if (!window.ecomm_currency) {
    logError('window.ecomm_currency is undefined');
    throw new Error('window.ecomm_currency is undefined');
  }
  return window.ecomm_currency;
};

const _validateEcommSearchTerm = () => {
  if (!window.ecomm_searchterm) {
    logError('window.ecomm_searchterm is undefined');
    throw new Error('window.ecomm_searchterm is undefined');
  }
  if (window.ecomm_searchterm === '') {
    logWarn('window.ecomm_searchterm is empty');
  }
  return window.ecomm_searchterm;
};
const _validateEcommItems = () => {
  if (!window.ecomm_items) {
    logError('window.ecomm_items is undefined');
    throw new Error('window.ecomm_items is undefined');
  }
  if (isArray(window.ecomm_items) && window.ecomm_items.length === 0) {
    logWarn('window.ecomm_items is empty');
  }
  return window.ecomm_items;
};
const _validateEcommShippingOptionName = () => {
  if (!window.ecomm_shippingoptionname) {
    logError('window.ecomm_shippingoptionname is undefined');
    throw new Error('window.ecomm_shippingoptionname is undefined');
  }
  if (window.ecomm_shippingoptionname === '') {
    logWarn('window.ecomm_shippingoptionname is empty');
  }
  return window.ecomm_shippingoptionname;
};
const _validateEcommShippingFeesEuro = () => {
  if (!window.ecomm_shippingfeeseuro) {
    logError('window.ecomm_shippingfeeseuro is undefined');
    throw new Error('window.ecomm_shippingfeeseuro is undefined');
  }
  if (window.ecomm_shippingfeeseuro === '') {
    logWarn('window.ecomm_shippingfeeseuro is empty');
  }
  return window.ecomm_shippingfeeseuro;
};
const _validateEcommEmail = () => {
  if (!window.ecomm_email) {
    logError('window.ecomm_email is undefined');
    throw new Error('window.ecomm_email is undefined');
  }
  return window.ecomm_email;
};

// pagina Checkout
const sendInitiateCheckout = ({ cartId, totaleuro, currency, items }) => {
  initLibs().then(() => {
    fbqBeginCheckout({
      currency,
      value: totaleuro,
      items,
      eventId: cartId,
    });

    ga4BeginCheckout({
      currency,
      totaleuro,
      items,
    });
    adsBeginCheckoutSendConversion({
      cartId,
      currency,
      totaleuro,
      items,
    });
  });
};

const _sendNewsletterRegistration = ({ url, email }) => {
  logDebug('_sendRegistration');
  fbqNewsletterRegistration({ url, email });
  ga4NewsletterRegistration({
    url,
    email,
  });
  adsNewsletterRegistrationSendConversion({
    email,
  });
};

const sendRegistration = ({ url, email }) => {
  return initLibs()
    .then(() => {
      try {
        _sendNewsletterRegistration({ url, email });
      } catch (error) {
        throw new Error(error.message);
      }
    })
    .catch((err) => {
      logError('sendRegistration from form ', err.message, url, email);
      return err;
    });
};

const _sendRegistration = () => {
  if (
    window.ecomm_pagetype &&
    window.ecomm_pagetype === pageTypes.registration
  ) {
    const email = _validateEcommEmail();
    _sendNewsletterRegistration({ url: window.location.href, email });
  }
};

const _sendFbqContact = () => {
  if (window.ecomm_pagetype && window.ecomm_pagetype === pageTypes.contact) {
    logDebug('_sendFbqContact');
    fbqContact();
  }
};

const _sendViewItem = () => {
  if (window.ecomm_pagetype && window.ecomm_pagetype === pageTypes.view_item) {
    logDebug('_sendGoogleAnalyticsFourViewItem');
    const currency = _validateEcommCurrency();
    const value = _validateEcommTotalValue();
    const items = _validateEcommItems();

    // Commentato per evitare eventi duplicati, essendoci dynamic remarketing
    ga4ViewItem({
      currency,
      value,
      items,
    });
    adsViewItemDynamicRemarketing({ value, items });
  }
};

const _sendSearchItemResults = () => {
  if (
    window.ecomm_pagetype &&
    window.ecomm_pagetype === pageTypes.view_search_results
  ) {
    logDebug('_sendSearchItemResults');
    const searchterm = _validateEcommSearchTerm();
    const items = _validateEcommItems();

    fbqSearch({ searchterm });
    ga4SearchItemsResults({ searchterm });
    adsSearchItemResultsDynamicRemarketing({ searchterm, items });
  }
};

const _sendViewItemList = () => {
  if (
    window.ecomm_pagetype &&
    window.ecomm_pagetype === pageTypes.view_item_list
  ) {
    logDebug('_sendViewItemList');
    const items = _validateEcommItems();
    ga4ViewItemList({
      items,
    });
    adsViewItemListDynamicRemarketing({ items });
  }
};

// pagina Summary
const sendViewCart = ({ cartId, currency, totaleuro, items }) => {
  logDebug('_sendViewCart');
  return initLibs().then(() => {
    ga4ViewCart({ cartId, currency, totaleuro, items });
  });
};

// Click "procedi al pagamento"
const sendShippingInfo = ({ cartId, currency, value, items, shippingTier }) => {
  logDebug('_sendGoogleAnalyticsFourShippingInfo');
  return initLibs().then(() => {
    ga4AddShippingInfo({
      cartId,
      currency,
      value,
      items,
      shipping_tier: shippingTier,
    });
  });
};

// Click "completa l'acquisto"
const addPaymentInfo = ({ payment, value, cartId, currency, items }) => {
  logDebug('addPaymentInfo');
  return initLibs().then(() => {
    fbqAddPaymentInfo({ currency, value, items, eventId: cartId });
    ga4AddPaymentInfo({ currency, value, items, payment });
    return payment;
  });
};

const closePopUp = () => {
  logDebug('closePopUp');
  return initLibs().then(() => {
    ga4ClosePopUp();
    return;
  });
};

const popUpButtonClick = () => {
  logDebug('popUpButtonClick');
  return initLibs().then(() => {
    ga4PopUpButtonClick();
    return;
  });
};

const initLibs = () => {
  // https://support.google.com/analytics/answer/7201382?hl=en

  return new Promise((resolve, reject) => {
    if (window.gtag && window.fbq) {
      logDebug('window.gtag && window.fbq ALL INITIALIZED!');

      const analytics4EnableDebug = validateGoogleData(
        'analytics4EnableDebug',
        false,
      );
      return resolve({
        gtag: window.gtag,
        fbq: window.fbq,
        analytics4EnableDebug,
      });
    }
    let retryCount = 4;
    const interval = setInterval(function () {
      try {
        logDebug('--> Run analytics script');

        const analytics4EnableDebug = validateGoogleData(
          'analytics4EnableDebug',
          false,
        );

        if (!window.gtag) {
          initGoogleAnalytics4({ debug: analytics4EnableDebug });
        }
        // FACEBOOK
        if (!window.fbq) {
          initFbq();
        }

        if (window.gtag && window.fbq) {
          logDebug('--> ga gtag and fbq ALL DEFINED');

          clearInterval(interval);
          return resolve({
            gtag: window.gtag,
            fbq: window.fbq,
            analytics4EnableDebug,
          });
        }
        if (retryCount === 0) {
          clearInterval(interval);
          return reject('Some function is not defined');
        }

        retryCount = retryCount - 1;
      } catch (error) {
        reject(error);
      }
    }, 1000);
  });
};

const addToCart = ({
  isKit,
  guid,
  quantity,
  options,
  currency,
  price,
  disciplines,
  categories,
  brandName,
  transactionId,
}) => {
  if (window.ecomm_pagetype && window.ecomm_pagetype === pageTypes.view_item) {
    initLibs().then(() => {
      const id = isKit ? guid : `${guid}-${options[0].optionId}`;
      fbqAddToCart({
        isKit,
        id,
        quantity,
        currency,
        price,
        eventId: transactionId,
      });
      const items = _validateEcommItems();

      // Commentato per evitare eventi duplicati, essendoci dynamic remarketing
      ga4AddToCart({
        id,
        quantity,
        currency,
        price,
        items,
        disciplines,
        categories,
        brandName,
      });

      adsAddToCartDynamicRemarketing({
        id,
        price,
      });
      adsAddToCartConversion({
        id,
        currency,
        price,
        items,
        transactionId,
      });
    });
  }
};

const viewItemFbq = async ({ slug, guid, options, currencyCode, isKit }) => {
  if (window.ecomm_pagetype && window.ecomm_pagetype === pageTypes.view_item) {
    await initLibs();

    fbqViewItem({ slug, guid, options, currencyCode, isKit });
  }
};

const _sendPurchase = () => {
  if (window.ecomm_pagetype && window.ecomm_pagetype === pageTypes.purchase) {
    const transaction_id = _validateEcommTransactionId();
    const currency = _validateEcommCurrency();
    const value = _validateEcommTotalValue();
    const items = _validateEcommItems();
    const shipping = _validateEcommShippingFeesEuro();
    const valueDecimal = parseFloat(value);
    const shippingDecimal = parseFloat(shipping);
    fbqPurchase({ currency, value, items, eventId: transaction_id });
    ga4Purchase({
      transaction_id,
      currency,
      value: valueDecimal,
      shipping: shippingDecimal,
      items,
    });
    purchaseDynamicRemarketing({
      value: valueDecimal,
      items,
    });

    logDebug(`Preparing purchaseConversion data...`);
    logDebug(`transaction_id ${transaction_id}`);
    const totalEuro = parseFloat(_validateEcommTotalValueEuro());
    logDebug(`totalEuro ${totalEuro}`);
    purchaseConversion({
      orderId: transaction_id,
      currency,
      totalEuro,
      items,
    });
  }
};

const sendGoogleSurvey = ({
  enableGoogleSurvey,
  merchantId,
  orderId,
  userEmail,
  deliveryCountry,
  estimatedDeliveryDate,
  surveyoptin,
}) => {
  const handleSurvey =
    window.ecomm_pagetype &&
    window.ecomm_pagetype === pageTypes.purchase &&
    enableGoogleSurvey;
  console.log('handleSurvey', handleSurvey);
  if (handleSurvey) {
    console.log('handle');

    const surveyObj = {
      merchant_id: merchantId,
      order_id: orderId,
      email: userEmail,
      delivery_country: deliveryCountry,
      estimated_delivery_date: estimatedDeliveryDate,
    };
    logEvent('gooogle survey', surveyObj);
    if (!surveyoptin) {
      logError('window.gapi.surveyoptin is not defined');
      return;
    }
    console.log('surveyoptin');
    surveyoptin.render(surveyObj);
  } else {
    logDebug(
      `Google survey script is disabled for merchantId ${merchantId}. Delivery country: ${deliveryCountry} Order id: ${orderId}`,
    );
  }
};

const run = () => {
  try {
    logDebug('Starting marketing and analytics service...');
    initLibs()
      .then(({ gtag, fbq, analytics4EnableDebug }) => {
        try {
          logDebug('window.googleData', window.googleData);
          logDebug('window.facebookData', window.facebookData);

          setConfigGoogleAnalytics4({ debug: analytics4EnableDebug });
          initConversions();
          let thirdPartyConsent = cookieService.getThirdParty();
          let marketingPartyConsent = cookieService.getMarketingParty();

          if (thirdPartyConsent) {
            logDebug('Executing actions for thirdPartyConsent...');
            fbqPixelId();
            fbqPageView();
          } else {
            logDebug(`No third party consent given`);
          }
          if (marketingPartyConsent) {
            logDebug('Executing actions for marketingPartyConsent...');

            _sendPurchase();

            _sendRegistration();
            _sendFbqContact();
            _sendViewItem();
            _sendSearchItemResults();
            _sendViewItemList();
          } else {
            logDebug(`No marketing consent given`);
          }
        } catch (error) {
          logError(`Error on run. ${error}`);
        }
      })
      .catch((err) => {
        logError(`Error on run after initializing libs. ${err}`);
      });
  } catch (error) {
    logError(`Error on run() : ${error}`);
  }
};

const recordBannerClick = async ({ linkUrl, title, index }) => {
  try {
    await initLibs();
    recordGA4BannerClick({ linkUrl, title, index });
  } catch (error) {
    logError(
      `Error recording banner click for url: ${linkUrl} - title: ${title} - index: ${index}`,
      error.message,
    );
  }
};

const recordPromoImagesClick = async ({
  linkUrl,
  promoMessage,
  index,
  imageSrc,
}) => {
  try {
    await initLibs();
    recordGA4PromoImagesClick({
      linkUrl,
      promoMessage,
      index,
      imageSrc,
    });
  } catch (error) {
    logError(
      `Error recording promo images click for url: ${linkUrl} - promoMessage: ${promoMessage} - index: ${index} - imageSrc: ${imageSrc}`,
      error.message,
    );
  }
};

const recordInfoboxClick = async ({ linkUrl }) => {
  try {
    await initLibs();
    recordGA4InfoboxClick({
      linkUrl,
    });
  } catch (error) {
    logError(
      `Error recording infoboxes click for url: ${linkUrl}`,
      error.message,
    );
  }
};

const recordNewsHomepageClick = async () => {
  try {
    await initLibs();
    recordGA4NewsHomepageClick();
  } catch (error) {
    logError(`Error recording news homepage click.`, error.message);
  }
};

const recordHelpClick = async () => {
  try {
    await initLibs();
    recordGA4HelpClick();
  } catch (error) {
    logError(`Error recording news homepage click.`, error.message);
  }
};
const recordCategoryClick = async ({ linkUrl }) => {
  try {
    await initLibs();
    recordGA4CategoryClick({ linkUrl });
  } catch (error) {
    logError(`Error recording category click for ${linkUrl}`, error.message);
  }
};

const recordLogonClick = async ({ linkUrl }) => {
  try {
    await initLibs();
    recordGA4LogonClick({ linkUrl });
  } catch (error) {
    logError(`Error recording logon click for ${linkUrl}`, error.message);
  }
};

const recordRegisterClick = async ({ linkUrl }) => {
  try {
    await initLibs();
    recordGA4RegisterClick({ linkUrl });
  } catch (error) {
    logError(`Error recording register click for ${linkUrl}`, error.message);
  }
};

export default {
  run,
  initLibs,
  addToCart,
  viewItemFbq,
  addPaymentInfo,
  closePopUp,
  popUpButtonClick,
  sendGoogleSurvey,
  sendInitiateCheckout,
  sendRegistration,
  sendShippingInfo,
  sendViewCart,
  recordBannerClick,
  recordPromoImagesClick,
  recordInfoboxClick,
  recordNewsHomepageClick,
  recordHelpClick,
  recordCategoryClick,
  recordLogonClick,
  recordRegisterClick,
};
